import { inject } from '@angular/core';
import { RoomApiService } from '@shared/services';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const roomTableConfig = (): TableConfig => {
  const roomApiService = inject(RoomApiService);

  return {
    title: 'Quản lý phòng',
    entityName: 'phòng',
    service: roomApiService,
    method: 'getRooms',
    columns: [
      { field: 'code', header: 'Mã phòng', width: 'min-w-[100px]', sortable: true, type: 'tag' },
      { field: 'name', header: 'Tên phòng', width: 'min-w-[100px]', sortable: true, type: 'text' },
      { field: 'center.code', header: 'Trung tâm', width: 'min-w-[100px]', sortable: true, type: 'tag', tagColor: 'center.tagColor', tagTextColor: 'center.tagTextColor' },
      { field: 'bestCap', header: 'Best Cap', width: 'min-w-[100px]', sortable: true, type: 'text' },
      { field: 'maxCap', header: 'Max Cap', width: 'min-w-[100px]', sortable: true, type: 'text' },
      { field: 'status', header: 'Trạng thái', width: 'min-w-[100px]', sortable: true, type: 'tag', tagType: 'roomStatus' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};
